'use strict';

angular.module('app.front', [
    'route',
    'ui.router',
]);
